import React, { Component } from 'react'
import { connect } from 'react-redux'

import { actualizarDatosParaMuiTable } from '../actions/TablaDetallePorCondicionLinea12Actions'
import { TablaDetallePorCondicionLinea12View } from '../components/TablaDetallePorCondicionLinea12View'

class TablaDetallePorCondicionLinea12 extends Component {
  componentDidMount () {
    this.props.actualizarDatosParaMuiTable()
  }

  render () {
    return <TablaDetallePorCondicionLinea12View />
  }
}

const mapActionsToProps = {
  actualizarDatosParaMuiTable
}
const withRedux = connect(null, mapActionsToProps)

export default withRedux(TablaDetallePorCondicionLinea12)
